import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class ThankYouPaid extends Component {
  render() {
    return (
      <div>
        <h2 className="text-center"><FormattedMessage id="CreateDomainLabel.completed"/></h2>
        <p className="text-center"><FormattedMessage id="CreateDomainLabel.sentInformation"/></p>
        <div className="box-shadow form-box">
          <div className="box-header text-center">
            <FormattedMessage id="CreateDomainLabel.confirmationInformation"/> 
          </div>
        </div>
        <button
          type="button"
          className="back-btn"
          onClick={this.props.closeModal} >
          X <FormattedMessage id="previewModal.close"/>
        </button>
      </div>
    );
  }
}

export default ThankYouPaid



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/ThankYouPaid.js